import * as actions from '../actions/groups';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import { failedGetSolicitorGroupCaseTypes, getSolicitorGroupCaseTypes, receiveSolicitorGroupCaseTypes } from '../reducers/internalAlertForm';

export function requestGroupExpensesCaseTypes(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_GROUP_EXPENSES_CASE_TYPES);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/Groups/' + action.payload + '/ExpensesCaseTypes'  ,
            category: 'requestGroupExpensesCaseTypes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestGroupExpensesCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGroupExpensesCaseTypes(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestGroupExpensesTypes(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGroupExpensesCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveGroupExpensesCaseTypes(response));

    return {
        ACTION: httpResponse$
    };
}

export function getGroupsOfSolicitors(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_GROUPS_OF_SOLICITORS)
        .map(action => ({
            url: BASE_URL + 'api/Groups/Solicitors',
            category: 'getGroupsOfSolicitors',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getGroupsOfSolicitors')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveSolicitorGroups(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseFromGettingGroupsOfSolicitors(sources) {
    let httpResponse$ = sources.HTTP
        .select('getGroupsOfSolicitors')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetGroupsOfSolicitors(response));

    return {
        ACTION: httpResponse$
    };
}

export function getSolicitorGroupById(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_SPECIFIC_SOLICITOR_GROUP)
        .map(action => ({
            url: BASE_URL + 'api/Groups/Solicitors/' + action.payload,
            category: 'getSolicitorGroupById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getSolicitorGroupById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetSpecificSolicitorGroup(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badRequestGetSolicitorById(sources) {
    let httpResponse$ = sources.HTTP
        .select('getSolicitorGroupById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >= 400)
        .map(response => actions.receiveBadRequestGetSpecificSolicitorGroup(response))

    return {
        ACTION: httpResponse$
    };
}

export function getUnderwriterOfSolicitorGroup(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP)
        .map(action => ({
            url: BASE_URL + 'api/Groups/'+ action.payload +'/Underwriter',
            category: 'getUnderwriterOfSolicitorGroup',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getUnderwriterOfSolicitorGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetUnderwriterOfSpecificSolicitorGroup(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badRequestGetUnderwriterOfSolicitor(sources) {
    let httpResponse$ = sources.HTTP
        .select('getUnderwriterOfSolicitorGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >= 400)
        .map(response => actions.receiveBadRequestGetUnderwriterOfSpecificSolicitorGroup(response));

    return {
        ACTION: httpResponse$
    };
}

//cycle method that requests and receives case types of solicitor group
export function requestSolicitorGroupCaseTypes(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_SOLICITOR_GROUP_CASE_TYPES || action.type === getSolicitorGroupCaseTypes.type)
        .map(action => ({
            url: BASE_URL + 'api/Groups/'+ action.payload +'/CaseTypes',
            category: 'requestSolicitorGroupCaseTypes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestSolicitorGroupCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => xs.of(actions.receiveSolicitorGroupCaseTypes(JSON.parse(response.text)),
        receiveSolicitorGroupCaseTypes(JSON.parse(response.text))))
        .flatten();

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

//cycle method that receives failed response from getting the case types of a solicitor group
export function badRequestGetSolicitorGroupCaseTypes(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestSolicitorGroupCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => xs.of(actions.failedToReceiveSolicitorGroupCaseTypes(response),
        failedGetSolicitorGroupCaseTypes())).flatten();

    return {
        ACTION: httpResponse$
    };
}


export function reqPatchSolGroup(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.PATCH_SOLICITOR_GROUP)
        .map(action => ({
            url: BASE_URL + 'api/Groups/Solicitors/'+ action.payload.key,
            category: 'reqPatchSolGroup',
            method: 'PATCH',
            send: action.payload.value,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('reqPatchSolGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveResponsePatchSolicitorGroup(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailPatchSolGroup(sources) {
    let httpResponse$ = sources.HTTP
        .select('reqPatchSolGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedPatchSolicitorGroup(response));

    return {
        ACTION: httpResponse$
    };
}
